<template>
  <div>
    <router-link
      :to="{ name: data['type'] + 'Show', params: { id: data['iri'] } }"
      v-html="text"
    >
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    q() {
      return this.$route.query.q
    },
    text() {
      if (this.q) {
        let searchMask = this.q;
        let regEx = new RegExp(searchMask, "ig");
        let replaceMask = `<span style="color: red;">${this.q}</span>`;

        return this.data['search'].replace(regEx, replaceMask)
      }

      return this.data['search']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/table/ColumnQ.vue